import { JobHoverData, Route, populateRoute } from "@repo/common"
import { request } from "../api"

/**
 * Fetches a single job's hover data (actions / booked items) on demand.
 * Wired into UniversalJobCard via JobHoverDataFetcherProvider so the card can
 * lazily load hover content only when a job is hovered.
 */
export async function fetchJobHover(
  jobId: string,
): Promise<JobHoverData | null> {
  const data = await request<JobHoverData | null>({
    url: populateRoute(Route.CALENDAR__JOB_HOVER, jobId),
    method: "GET",
  })
  // The endpoint returns null when a job has no hover content; an empty HTTP
  // body deserializes to "" rather than null, so normalize any falsy value.
  return data || null
}
